define('drops/qrCode_v2/qrCode_v2',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/multiSourceValue'
], function ($, lq, Drop, multiSourceValue) {
    'use strict';

    var defaults = {
        data: {
            contentType: 'applicationUrl',
            content: multiSourceValue.createEmptyValue()
        }
    };

    function QrCode(options) {
        Drop.call(this, $('<div />'), defaults, options);

        this.$element
	        .addClass('boxToBorderSize')
            .css({
                'background-repeat': 'no-repeat',
                'background-size': 'contain'
            });
    };

    Drop.extend(QrCode, Drop);

    QrCode.typeName = 'QrCode_v2';

    QrCode.prototype.preRender = function () {
        var self = this;
        this.piping.visibility.apply(this);
        this.applyPosition();
        this.setImage(this.getImageUrl());
        
        multiSourceValue.initializeUpdates(
            this,
            this.data.content,
            function () {self.setImage(self.getImageUrl());}
        );
    };

    QrCode.prototype.setImage = function (url) {
        this.$element.css('background-image', 'url(' + url + ')');
    };

    QrCode.prototype.getImageUrl = function () {
        return lq.getTenantUrl('GeneratedContent/QrCode/'
            + '?actionId=' + this.rootDrop.data.id
            + '&qrCodeId=' + this.data.id
            + '&v2=true'
            + '&parameters=' + encodeURIComponent(JSON.stringify(this.piping.parameters.getNonSystemParameters()))
            + '&width=' + this.data.size.x
            + '&height=' + this.data.size.y);
    };

    return QrCode;
});
